var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper layout-default",class:{ gray: _vm.isGray, darkgray: _vm.isDarkGray }},[_c('main',[_c('RouterView',[_vm._t("default")],2)],1),_c('PWASuggestion'),_c('NewVersion'),_c('AdminAccountWarning')],1)}
var staticRenderFns = []

export { render, staticRenderFns }